import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // Temporarily comment out StrictMode for development to avoid double calls
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);
